<accordion [isAnimated]="true" class="accordion-section" style="width: 100%">
    <accordion-group [heading]="header" class="accordion-section-tittle">
        <p *ngFor="let texto of textos" class="text-justify recuo">{{texto}} <br /><br /></p>
    </accordion-group>
</accordion>